import React from "react";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import {
  modalHeightVariants,
  modalVariants,
} from "../../../animation/RoutesAnimations";
import { ContactInfoProps } from "../../../pages/admin-dashboard/admin-dashboard-basicInfo/banks/type";

const ContactInfo: React.FC<ContactInfoProps> = ({
  onShowModalChange,
  storeName,
  phoneNumber,
  telNumber,
  logoShop,
}) => {
  const handlePhoneClick = () => {
    const phoneNumber = `tel:021 ${telNumber}`;
    window.location.href = phoneNumber;
  };

  return ReactDOM.createPortal(
    <>
      <motion.div
        variants={modalVariants}
        initial="initial"
        animate="final"
        id="static-modal"
        data-modal-backdrop="static"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-screen bg-gray-500 bg-opacity-50"
      >
        <motion.div
          layout
          variants={modalHeightVariants}
          initial="initial"
          animate="final"
          className={`relative w-[400px] overflow-hidden bg-white rounded-lg shadow pb-4 px-4 `}
        >
          <motion.div
            layout={"position"}
            initial="initial"
            animate="final"
            className="relative "
          >
            <div className="w-full pl-4 pt-2 flex items-center justify-between">
              <span className="invisible">Close modal</span>
              <svg
                className="w-3 h-3 hover:cursor-pointer"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
                onClick={() => onShowModalChange(false)}
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </div>
            <div className="grid mt-5 items-center justify-center">
              <div className="grid items-center justify-center w-[80px] h-[80px] rounded-full bg-primary-100  mx-auto">
                <img
                  src={logoShop}
                  alt="Store"
                  className="object-cover rounded-full w-[64px] h-[64px] border border-primary-600"
                />
              </div>
              <label className="flex items-center justify-center text-Title/16/Regular mt-6 ">
                {storeName}
              </label>
              <div className="flex gap-4">
                <label className="text-Title/14/Regular mt-6 ">
                  شماره ثابت:
                </label>
                <label
                  className="text-Title/20/Bold mt-6 cursor-pointer "
                  onClick={handlePhoneClick}
                  dir="ltr"
                >
                  {telNumber}
                </label>
              </div>
              <div className="flex gap-4">
                <label className="text-Title/14/Regular mt-6 ">
                  شماره همراه:
                </label>
                <label
                  className="text-Title/20/Bold mt-6 cursor-pointer "
                  onClick={handlePhoneClick}
                  dir="ltr"
                >
                  {phoneNumber}
                </label>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </>,
    document.getElementById("modal-root")!
  );
};

export default ContactInfo;
